import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { GACODE } from "./constants";
import "./CookieConsent.scss";

declare global {
  interface Window {
    dataLayer: any[];
    gtag?: (...args: any[]) => void;
  }
}

const CookieConsent: React.FC = () => {
  const [showBanner, setShowBanner] = useState<boolean>(
    Cookies.get("cookie_consent") === null ||
      Cookies.get("cookie_consent") === undefined
      ? true
      : false
  );
  // todo - ovo staviti kada bude mogao da odbije cookie
  // Cookies.get("cookie_consent") !== "true"

  const appendGtagScript = (): void => {
    if (!document.getElementById("google-analytics")) {
      // 1. Dodaj gtag.js skriptu
      const script = document.createElement("script");
      script.id = "google-analytics";
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GACODE}`;
      document.head.appendChild(script);

      // 2. Inicijalizuj dataLayer i gtag funkciju
      // Kada se skripta učita, tek tada inicijalizuj gtag i default consent
      script.onload = () => {
        const initScript = document.createElement("script");
        initScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
      `;
        document.head.appendChild(initScript);
      };

      document.head.appendChild(script);
    }
  };

  const loadDefaultConsentMode = (): void => {
    window.dataLayer = window.dataLayer || [];

    // Postavi default režim saglasnosti
    if (typeof window.gtag === "function") {
      window.gtag("consent", "default", {
        ad_storage: "denied",
        analytics_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        functionality_storage: "denied",
        personalization_storage: "denied",
        security_storage: "granted", // obično se ostavlja kao granted
      });
    } else {
      // Ako gtag još nije učitan, sačekaj dok se ne pojavi
      window.dataLayer.push({
        event: "default_consent",
        ad_storage: "denied",
        analytics_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        functionality_storage: "denied",
        personalization_storage: "denied",
        security_storage: "granted",
      });
    }
  };

  // Funkcija za učitavanje Google Analytics-a
  const loadGrantedConsentMode = (): void => {
    if (window.gtag) {
      // Updateuj rezim saglasnosti kada korisnik prihvati cookie
      window.gtag("consent", "update", {
        ad_storage: "granted",
        analytics_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
        functionality_storage: "granted",
        personalization_storage: "granted",
        security_storage: "granted",
      });
      // load google analytics
      window.gtag("config", GACODE);

      // Pošalji događaj u GA da znaš koliko ljudi je prihvatilo kolačiće
      window.gtag("event", "cookie_consent_given", {
        event_category: "Consent",
        event_label: "User accepted cookies",
      });
    } else {
      console.warn("Google Analytics gtag nije dostupan.");
    }
  };

  // Klik na "Accept" postavlja kolačić i učitava GA
  const handleAcceptCookies = (): void => {
    Cookies.set("cookie_consent", "true", { expires: 90 }); // Kolačić važi 1 godinu
    setShowBanner(false);
    loadGrantedConsentMode();
  };

  // Ako je korisnik već prihvatio kolačiće, odmah učitavamo GA
  useEffect(() => {
    appendGtagScript();
    // Sačekaj kratko da se skripta učita, pa podesi consent
    const timer = setTimeout(() => {
      if (Cookies.get("cookie_consent") === "true") {
        loadGrantedConsentMode();
      } else {
        loadDefaultConsentMode();
      }
    }, 500); //mala pauza da se skripta ucita

    return () => clearTimeout(timer);
  }, []);

  return showBanner ? (
    <div className="cookie-banner">
      <p>
        Ovaj sajt koristi kolačiće za poboljšanje vašeg iskustva, prikazivanje
        personalizovanog sadržaja i reklama, kao i analizu saobraćaja.
      </p>
      <p>
        Više informacija pronađite u našoj Politici privatnosti. Klikom na
        <i> Prihvati </i> saglašavate se sa korišćenjem kolačića.
      </p>
      <div className="cookie-banner-buttons">
        <button onClick={handleAcceptCookies}>Prihvati</button>
      </div>
    </div>
  ) : null;
};

export default CookieConsent;
